import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#F1F1F2',
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid #DADCDD',
    boxShadow: '0 2px 2px rgba(0, 0, 0, 0.14)',
    fontSize: theme.typography.pxToRem(14),
    borderRadius: '4px',
    padding: '15px',
    maxWidth: '300px',
    '@media (max-width: 480px)': {
      fontSize: theme.typography.pxToRem(12),
      padding: '10px',
      maxWidth: '250px',
    },
    '@media (max-width: 800px)': {
      fontSize: theme.typography.pxToRem(13),
      padding: '12px',
      maxWidth: '280px',
    },
  },
}))

export default CustomTooltip
